import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Input } from 'antd';
import { getUsers } from '../../actions/UsersAction'
// const { Search } = Input

export class ListSearcher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
    }
  }

  componentDidMount() {
    const { client } = this.props
    this.setState({ workclient: client })
  }

  handleSearch = e => {
    const { client, type } = this.props
    const { value } = e.target
    this.setState({ value })
    switch (type) {
      case 'users':
        this.handleFilterUsers(value, client)
        break;
      default:
    }
  }

  handleFilterUsers = (criteria, client) => {
    if (criteria.length !== 0) {
      this.props.getUsers(client, 1, criteria)
    }
  }

  handleOnchage = e => {
    this.setState({ value: e.target.value })
  }

  handleOnSearch = () => {
    const { client } = this.props
    this.setState({ value: '' })
    this.props.getUsers(client, 1)
  }

  render() {
    const { placeholder, fNameOrEmail } = this.props //loading
    // const { value } = this.state
    return (
      <React.Fragment>
        <Input
          placeholder={placeholder}
          allowClear
          // onSearch={this.handleOnSearch}
          // onSearch={this.props.handleOnSearch}
          // enterButton={searchButtonText}
          style={{ marginBottom: '10px', width: '550px', marginRight: '30px' }}
          // loading={loading}
          // onPressEnter={this.handleSearch}
          onKeyUp={this.props.filterByNameOrEmail}
          value={fNameOrEmail}
          // onChange={this.handleOnchage}
          onChange={this.props.handleOnchageSearch}
        />
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    searcher: state.users.searcher,
  }
}

const mapDispatchToProps = {
  getUsers,
}

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps, mapDispatchToProps)(ListSearcher)
  )
)